import "./JavaScript/Project/globals";

import "object-fit-videos";
import "vanilla-lazyload";
import "lazyembed2";
import "jquery";
import "@popperjs/core";

/**
 * Bootstrap
 */
import "bootstrap/js/src/util";
//import 'bootstrap/js/src/alert';
//import 'bootstrap/js/src/button';
//import 'bootstrap/js/src/carousel';
import "bootstrap/js/src/collapse";
//import 'bootstrap/js/src/dropdown';
//import 'bootstrap/js/src/modal';
//import 'bootstrap/js/src/scrollspy';
import "bootstrap/js/src/tab";
//import 'bootstrap/js/src/tooltip';
//import 'bootstrap/js/src/popover';

/**
 * Bootstrap Multiselect
 */
//import 'bootstrap-multiselect';

/**
 * Slick
 */
import "slick-carousel";

/**
 * Light Galery
 */
import "lightgallery";
import "lg-autoplay";
//import 'lg-fullscreen';
//import 'lg-hash';
//import 'lg-pager';
//import 'lg-share';
//import 'lg-thumbnail';
import "lg-video";
//import 'lg-zoom';

/**
 * Project
 */

import "./JavaScript/Project/viewport";
import "./JavaScript/Project/sizeChange";
import "./JavaScript/Project/PageLoadedQueue";
import "./JavaScript/Project/objectFitVideos";
import "./JavaScript/Project/counter";
import "./JavaScript/Project/circleCounter";
import "./JavaScript/Project/downloadFilters";
import "./JavaScript/Project/lightGallery";
import "./JavaScript/Project/lazyload";
import "./JavaScript/Project/lazyEmbed";
import "./JavaScript/Project/slick";
import "./JavaScript/Project/menu";

import "../../../../Avency.Sprehe.Horses/Resources/Private/Fusion/Component/Organsim/Slider";
import "../../../../Avency.Sprehe.Horses/Resources/Private/Fusion/Component/Molecule/HorseListView/HorseListView";
import "../../../../Avency.Sprehe.Horses/Resources/Private/Fusion/Component/Molecule/HorseInfo/HorseInfo";
import "../../../../Avency.Sprehe.Forms/Resources/Private/Fusion/Component/Organism/OrderForm/OrderForm";
import "../../../../Avency.Sprehe.News/Resources/Private/Fusion/Component/Atom/NewsTeaserSmall/NewsTeaserSmall";
